<template>
  <div>
    <div
      id="hero-section"
      class="ui middle aligned padded grid"
      :style="{ background: 'url(' + activeLandingPageContent.heroImageBackgroundLink + ') center / cover ' }">

      <!--<div class="row">-->
        <div class="ui sixteen wide mobile six wide tablet six wide computer column">
          <center><img class="ui image" :src="activeLandingPageContent.heroImageLink"></center>
        </div>

        <div class="ui ten wide tablet only ten wide computer only column">
          <h1 class="ui teal header hero-header"> {{ activeLandingPageContent.heroImageHeader }}</h1>
          <p style="color: ghostwhite;">{{ activeLandingPageContent.heroImageSubheader }}</p>

          <div
            class="ui teal circular button"
            style="font-weight: normal;"
            @click="registerInterest"><i class="envelope icon"/> &nbsp; {{ activeLandingPageContent.heroImageCTA }}</div>
        </div>

      <div class="ui sixteen wide mobile only column">
        <center>
          <h1 class="ui teal header hero-header"> {{ activeLandingPageContent.heroImageHeader }}</h1>
          <p style="color: ghostwhite;">{{ activeLandingPageContent.heroImageSubheader }}</p>
        </center>
        <br>
          <div
            class="ui teal fluid circular big button"
            style="font-weight: normal;"
            @click="registerInterest"><i class="envelope icon"/> &nbsp; {{ activeLandingPageContent.heroImageCTA }}</div>
          <br>
      </div>

      </div>
    </div>
</template>

<script>
export default {
  name: 'HeroImage',
  data () {
    return {

    }
  },
  methods: {
    registerInterest() {
      if (typeof(this.$route.query.referral) === 'undefined') {
        if (this.$route.params.variant.toLowerCase() === 'symptom-tracker') {
          window.open(process.env.VUE_APP_SYMPTOMTRACKER_TYPEFORM + '?source=' + this.$route.params.variant, '_blank')
        }
        else {
          window.open(process.env.VUE_APP_CROWDSOURCE_TYPEFORM + '?source=' + this.$route.params.variant, '_blank')
        }
      } else {
        if (this.$route.params.variant.toLowerCase() === 'symptom-tracker') {
          window.open(process.env.VUE_APP_SYMPTOMTRACKER_TYPEFORM + '?source=' + this.$route.params.variant + '&referral=' + this.$route.query.referral, '_blank')
        }
        else {
          window.open(process.env.VUE_APP_CROWDSOURCE_TYPEFORM + '?source=' + this.$route.params.variant + '&referral=' + this.$route.query.referral, '_blank')
        }
      }
    }
  }
}
</script>

<style scoped>
  #hero-section {
    min-height: 80vh;
  }

  .hero-header {
    font-size: 2em !important;
  }
</style>
